var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _vm.salesPitchDto.title
        ? _c("header-signature", {
            staticClass: "pb-1",
            attrs: { text: _vm.salesPitchDto.title },
          })
        : _vm._e(),
      _vm._v(" "),
      _c("div", { staticClass: "bg-gray2 p-1 ps-lg-2 pe-lg-2" }, [
        _c(
          "div",
          { staticClass: "accordion" },
          _vm._l(_vm.salesPitchDto.pitches, function (pitch, index) {
            return _c("div", { key: index }, [
              _c("div", { staticClass: "card multi" }, [
                _c("div", { staticClass: "card-header" }, [
                  _c(
                    "button",
                    {
                      staticClass: "collapsed",
                      attrs: {
                        "data-bs-toggle": "collapse",
                        "data-bs-target": "#pitch-collapse-" + index,
                        "aria-controls": "#" + "pitch-collapse-" + index,
                        "aria-expanded": "false",
                      },
                    },
                    [
                      _c(
                        "span",
                        {
                          staticClass:
                            "d-flex align-items-center accordion-card-title",
                        },
                        [
                          _c("span", {
                            staticClass: "item-icon",
                            class: pitch.iconName,
                            attrs: { "aria-hidden": "true" },
                          }),
                          _vm._v(" "),
                          _c("span", {
                            staticClass: "accordion-title",
                            domProps: { innerHTML: _vm._s(pitch.title) },
                          }),
                          _vm._v(" "),
                          _c("span", {
                            staticClass: "accordion-icon",
                            attrs: { "aria-hidden": "true" },
                          }),
                        ]
                      ),
                    ]
                  ),
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "collapse",
                    attrs: {
                      id: "pitch-collapse-" + index,
                      "aria-labelledby": "pitch-" + index,
                    },
                  },
                  [
                    _c("div", { staticClass: "accordion-card-body standard" }, [
                      _c("p", {
                        staticClass: "mb-0 py-0",
                        domProps: { innerHTML: _vm._s(pitch.descriptionHtml) },
                      }),
                    ]),
                  ]
                ),
              ]),
            ])
          }),
          0
        ),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }